export const replacePlaceholders = ({template, data}) => {
  return template.replace(/<([^>]+)>/g, (_, key) => data[key] || `<${key}>`);
};
